import _ from 'lodash';
import geocode from '../app/geocode';
import initDateTimePickers from '../init/datetimepicker';
import setupScheduleForm from './schedule_form';

function updateCoordinates($el, lat, lng) {
  $el.find('#driver_address_attributes_lat').val(lat);
  $el.find('#driver_address_attributes_lng').val(lng);
  $el.find('input.driver-address-coordinates').val(`${lat}, ${lng}`);
}

function setupAddressField() {
  const selector = _.map(['street', 'npa', 'city'],
    value => `#driver_address_attributes_${value}`).join(', ');
  $(selector).off('change').on('change', () => {
    const $inputs = $(selector);
    const $row = $inputs.parents('.row');
    updateCoordinates($row, '', '');
    geocode(..._.map($inputs, 'value')).then(({ lat, lng }) => {
      updateCoordinates($row, lat, lng);
    }).catchReturn();
  });
}

function setupLicenseCategories() {
  const $container = $('#driver-license-categories');
  $container.find('span[data-category]').off('click').on('click', ({ currentTarget }) => {
    const $span = $(currentTarget);
    $span.toggleClass('active');
    if ($span.hasClass('active')) {
      $container.append($('<input />').attr({
        multiple: 'multiple',
        value: $span.data('category'),
        type: 'hidden',
        name: 'driver[categories][]',
      }));
    } else {
      $container.find(`input[value='${$span.data('category')}']`).remove();
    }
  });
}

function setupHolidaysForm() {
  $('.modal-driver .modal-body #tab-holidays').off('click')
    .on('click', '.btn-row-actions:has(.fa.fa-plus)', ({ currentTarget }) => {
      const $template = $(currentTarget).parents('.row');
      const $clone = $template.clone();
      const index = $('.holidays-rows > .row').length;
      $template.parent().append($clone);
      $template.find('.fa.fa-plus').removeClass('fa-plus').addClass('fa-trash');

      _.forEach($clone.find('input'), (input) => {
        const $input = $(input);
        const name = $input.attr('name').replace(/(driver\[driver_events_attributes\]\[)(\d+)(\]\[\w+\])/, `$1${index}$3`);
        $(input).attr('name', name);
        if (!$input.hasClass('driver_event_holiday')) { $(input).val(''); }
      });

      initDateTimePickers();
    })
    .on('click', '.btn-row-actions:has(.fa.fa-trash)', ({ currentTarget }) => {
      const $row = $(currentTarget).parents('.row');
      const index = $row.index(('.holidays-rows > .row'));
      if (!$row.find('input.driver_event_id').val()) {
        return $row.remove();
      }
      $row.addClass('hide');
      return $row.append($('<input>').attr('name', `driver[driver_events_attributes][${index}][_destroy]`).val(true));
    });
}

$(document).on('ready turbolinks:load', () => {
  setupAddressField();
  setupLicenseCategories();
  setupHolidaysForm();
  setupScheduleForm();
});
